const assetTransformer = require('./asset');
const isResolvedResource = require('../contentful/is-resolved-resource');
const isResolvedCollection = require('../contentful/is-resolved-collection');

const BlockTypes = {
  IMAGE: 'imageBlock',
  TEXT: 'textBlock',
  WIDGET: 'widgetBlock'
};

const WidgetTypes = {
  LEASE: 'leaseBasic',
  TEXT: 'text',
  HTML: 'html',
  MD: 'markdown',
  WYSIWYG: 'wysiwyg',
  GALLERY: 'gallery',
  FAQ: 'faq',
  MODEL_CAMPAIGNS: 'modelCampaigns',
  MODEL_ARTICLES: 'modelArticles',
  MODEL_GALLERIES: 'modelGalleries',
  MODEL_BROCHURES: 'modelBrochures',
  MODEL_STOCKCARS: 'modelStockCars',
  MODEL_EQUIPMENTLEVELS: 'modelEquipmentlevels'
};


const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal: (block) => {
    const result = {
      id: block.sys.id,
      type: block.sys.contentType.sys.id,
      published: !!block.sys.publishedVersion,
      updated: block.sys.publishedVersion && block.sys.version > block.sys.publishedVersion + 1
    };

    switch (result.type) {
      case BlockTypes.TEXT:
        result.text = block.fields.text['nb-NO'];
        break;
      case BlockTypes.IMAGE:
        result.image = null;
        if (block.fields.image['nb-NO'] && isResolvedResource(block.fields.image['nb-NO'])) {
          result.image = assetTransformer.contentfulToInternal(block.fields.image['nb-NO']);
        }
        if (block.fields.url && block.fields.url['nb-NO']) {
          result.url = block.fields.url['nb-NO'];
        }
        if (block.fields.urlInTab && block.fields.urlInTab['nb-NO']) {
          result.urlInTab = block.fields.urlInTab['nb-NO'];
        }
        if (block.fields.data && block.fields.data['nb-NO']) {
          result.data = block.fields.data['nb-NO'];
        }
        break;
      case BlockTypes.WIDGET:
        result.widget = block.fields.type['nb-NO'];
        if (block.fields.data && block.fields.data['nb-NO']) {
          result.data = block.fields.data['nb-NO'];
        }
        if (block.fields.content && block.fields.content['nb-NO']) {
          result.content = block.fields.content['nb-NO'];
        }
        if (block.fields.media && block.fields.media['nb-NO'] && isResolvedCollection(block.fields.media['nb-NO'])) {
          result.media = block.fields.media['nb-NO'].map(assetTransformer.contentfulToInternal);
        }
        break;
      default:
        throw new Error(`Unknown block type ${result.type}.`);
    }

    return result;
  },

  internalToContentful: (block) => {
    if (!block.type) {
      throw new Error('Block transformer expects block to have a type.');
    }

    const result = {};

    if (block.id) {
      result.sys = {
        id: block.id
      };
    } else {
      result.sys = {
        contentType: {
          sys: {
            id: block.type
          }
        }
      };
    }

    switch (block.type) {
      case BlockTypes.TEXT:
        result.fields = {
          text: {
            'nb-NO': block.text
          }
        };
        break;
      case BlockTypes.IMAGE:
        result.fields = {
          image: {
            'nb-NO': block.image ? createAssetLink(block.image) : null
          }
        };

        if (block.data) {
          result.fields.data = {
            'nb-NO': block.data
          };
        }
        if (block.url !== undefined) {
          result.fields.url = {
            'nb-NO': block.url
          };
        }
        if (block.urlInTab !== undefined) {
          result.fields.urlInTab = {
            'nb-NO': block.urlInTab
          };
        }
        break;
      case BlockTypes.WIDGET:
        result.fields = {
          type: {
            'nb-NO': block.widget
          }
        };
        if (block.data) {
          result.fields.data = {
            'nb-NO': block.data
          };
        }
        if (block.content) {
          result.fields.content = {
            'nb-NO': block.content
          };
        }
        if (block.media) {
          result.fields.media = {
            'nb-NO': block.media.map(createAssetLink)
          };
        }
        break;
      default:
        throw new Error(`Unknown block type ${block.type}.`);
    }

    return result;
  },

  BlockTypes: BlockTypes,
  WidgetTypes: WidgetTypes
};
